import $ from 'jquery';
import './jquery.timepicker';
import * as helpers from '../helpers';
import l10n from '../lang/locallang';

export function hasNativeDatePicker() {
    const elem = document.createElement('input');

    elem.setAttribute('type', 'date');
    elem.value = 'foo';

    return (elem.type === 'date' && elem.value !== 'foo');
}

export function dateManagement() {
    // const inputDate = $('input[type=date]:not(.datepicker)')
    const inputDate = document.querySelectorAll('input[type="date"]:not(.datepicker)');

    const frenchToInternationalDate = (value) => {
        const dateArray = value.split(/[-/.]/);

        return ((dateArray[0] && dateArray[1] && dateArray[2]) ? `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}` : '');
    };

    const internationalDateTofrench = (value) => {
        const dateArray = value.split(/[-/.]/);

        return ((dateArray[0] && dateArray[1] && dateArray[2]) ? `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}` : '');
    };

    const checkFrenchDateFormat = (value) => {
        const regex = /^[0-9]{2}[/.-][0-9]{2}[/.-][0-9]{4}$/;

        return regex.test(value);
    };

    const checkInternationalDateFormat = (value) => {
        const regex = /^(\d{4})([/-])(\d{1,2})\2(\d{1,2})$/;

        return regex.test(value);
    };

    const labelHelper = (elem) => {
        const parent = elem.parentNode;
        const label = parent.querySelector('label');

        const labelFor = label.getAttribute('for');

        if (!label) {
            console.error('Error: label does not exist or not found');
            return false;
        }

        label.setAttribute('for', `${labelFor}-origin`);
        label.insertAdjacentHTML('beforeend', '<span class="helper">&nbsp;(jj/mm/aaaa)</span>');
    };

    const addHiddenField = (elem) => {
        const elemName = elem.name;
        const elemId = elem.id;
        const elemClass = elem.classList.contains('dateselector');
        const hiddenField = document.createElement('input');

        if (!elemId) {
            return false;
        }

        document.getElementById(elemId).id = `${elemId}-origin`;

        // change for attribute on label
        hiddenField.type = 'hidden';
        hiddenField.name = elemName;
        hiddenField.id = elemId;

        if (elemClass) {
            elem.classList.remove('dateselector');
            hiddenField.classList.add('dateselector');
        }

        helpers.insertAfter(hiddenField, elem);

        elem.removeAttribute('name');
    };

    const addValue = (elem) => {
        const value = elem.value;
        const hiddenField = elem.parentNode.querySelector('input[type=hidden]');

        if (hiddenField) {
            hiddenField.value = frenchToInternationalDate(value);
        }
    };

    const checkError = (elem) => {
        const required = elem.hasAttribute('required');

        return !((!required && (checkFrenchDateFormat(elem.value) || elem.value === ''))
            || (required && elem.value !== '' && checkFrenchDateFormat(elem.value)));
    };

    const addError = (elem, errorMessage) => {
        const nodeError = elem.parentNode.querySelector('.error');

        const message = errorMessage || ` ${l10n.entryError}`;

        if (!nodeError) {
            const elemId = elem.getAttribute('id');

            if (!elemId) {
                console.error('This field has no id, it is required.');
            } else {
                const alertContainer = document.createElement('div');
                alertContainer.setAttribute('id', `${elemId}-relation`);
                alertContainer.classList.add('error');
                alertContainer.classList.add('parsley-errors-list');

                elem.setAttribute('aria-describedby', `${elemId}-relation`);

                helpers.insertAfter(alertContainer, elem);

                const alertP = document.createElement('p');
                alertP.classList.add('parsley-required');
                alertP.innerHTML = ` ${message}`;
                alertContainer.appendChild(alertP);
            }
        }
    };

    const removeError = (elem) => {
        const nodeError = elem.parentNode.querySelector('.error');

        if (nodeError) {
            elem.parentNode.removeChild(nodeError);
            elem.removeAttribute('aria-describedby');
        }
    };

    const emptyField = (elem) => {
        if (checkInternationalDateFormat(elem.value)) {
            elem.value = internationalDateTofrench(elem.value);
            addValue(elem);
        }
    };

    const filledField = (elem) => {
        // If french format, add value on hidden field
        if (checkFrenchDateFormat(elem.value)) {
            addValue(elem);
        } else if (checkInternationalDateFormat(elem.value)) { // If user fill in international format, transform in french and add value on hidden field
            elem.value = internationalDateTofrench(elem.value);
            addValue(elem);
        }
    };

    const initError = (event, elem) => {
        // Check error
        if (checkError(elem)) {
            event.preventDefault();
            addError(elem);
        } else {
            removeError(elem);
        }

        // Add value in hidden field
        filledField(elem);
    };

    const initInputMask = (elem) => {
        elem.addEventListener('input', (e) => {
            const currentValue = elem.value;
            const prevValue = currentValue.slice(0, -1);
            const len = currentValue.length;
            const input = String.fromCharCode(e.keyCode);

            // Abort if divider or forward slash
            if (e.keyCode === 191 || e.keyCode === 111) {
                e.preventDefault();
                return;
            }

            if (len < 10 && e.keyCode !== 8) {
                switch (len) {
                    case 2:
                    case 5:
                        elem.value = `${currentValue}/`;
                        break;
                    default:
                }
            } else if (len !== 0 && /[a-zA-z0-9ÝÛÞºÜ¾¼¿]/.test(input)) {
                elem.value = prevValue;
            }
        });
    };


    const init = (elem) => {
        const form = elem.form;
        const ancestor = helpers.findAncestor(elem, 'ancestor');

        // initInputMask(elem);
        labelHelper(elem);
        addHiddenField(elem);

        elem.setAttribute('placeholder', 'jj/mm/aaaa');

        // Check when page is reloaded or return of the form
        if (elem.value) {
            emptyField(elem);
        }

        // Submit
        if (form) {
            form.addEventListener('submit', (event) => {
                initError(event, elem);
            });
        } else if (ancestor) { // If form does not exist, ancestor with the class .ancestor required
            const submitButton = ancestor.querySelector('button[type="submit"]');

            submitButton.addEventListener('click', (event) => {
                initError(event, elem);
            });
        } else {
            return false;
        }
    };

    if (!hasNativeDatePicker()) { // If has no native datepicker (IE11, Safari macOS)
        for (let i = 0; i < inputDate.length; i++) {
            const elem = inputDate[i];
            init(elem);
        }
    } else {
        for (let i = 0; i < inputDate.length; i++) {
            const elem = inputDate[i];
            const form = elem.form;
            const ancestor = helpers.findAncestor(elem, 'ancestor');
            const required = elem.hasAttribute('required');

            if (form) {
                form.addEventListener('submit', (event) => {
                    if (required && elem.value === '') {
                        event.preventDefault();
                        addError(elem, ` ${l10n.fillFieldRequired}`);
                    } else {
                        removeError(elem);
                    }
                });
            } else if (ancestor) { // If form does not exist, ancestor with the class .ancestor required
                const submitButton = ancestor.querySelector('button[type="submit"]');

                submitButton.addEventListener('click', () => {
                    // Run specific script (solr)
                });
            }
        }
    }
}

export function enableTimePicker() {
    $('.time input').timepicker({
        timeFormat: 'H:i',
    });
}
